import React from 'react'

import { Controller, useForm } from 'react-hook-form'
import { Search as SearchIcon, X as XIcon } from 'react-feather'
import { IconButton, InputAdornment, TextField } from '@material-ui/core'

import useStyles from './styles'

const SearchBar = ({ filter, fieldName = '', placeholder = 'Pesquisar' }) => {
  const classes = useStyles()

  const { handleSubmit, control, watch, setValue } = useForm({
    defaultValues: { [fieldName]: '' },
  })

  const nameValue = watch(fieldName)

  const onSubmit = (data) =>
    filter.setFilters({
      ...filter.filters,
      [fieldName]: data?.[fieldName],
    })

  const handleClear = () => {
    setValue(fieldName, '')
    filter.setFilters({
      ...filter.filters,
      [fieldName]: '',
    })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        as={
          <TextField
            placeholder={placeholder}
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {nameValue ? (
                    <IconButton size="small" onClick={handleClear}>
                      <XIcon className={classes.searchIcon} />
                    </IconButton>
                  ) : (
                    <IconButton type="submit" size="small">
                      <SearchIcon className={classes.searchIcon} />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
            fullWidth
          />
        }
        control={control}
        name={fieldName}
        mode="onChange"
      />
    </form>
  )
}

export default SearchBar
